import React, { useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import CreateClaim from "./CreateClaim";
import ClaimInfo from "./ClaimInfo";
import CancelClaim from "./CancelClaim";
import { useDispatch } from "react-redux";
import {
  useTrackJeeblyOrderMutation,
  useCancelJeeblyOrderMutation,
} from "redux/Logistic/JeeblyService";
import { UTILS } from "utils";
import { LoaderAction } from "redux/actions";
import { errorHandler } from "api/api/errorHandler";
import ModalTabs from "logistic-integrations/components/Tabs";
import IFastSupport from "./IFastSupport";
import {useCheckOrderStatusMutation, useCancelIfastOrderMutation} from "redux/Logistic/IfastService"
const { TabPane } = Tabs;
const DeliveryService = (props) => {
  const { t } = useTranslation();
  const { setOpen, order } = props;
  const dispatch = useDispatch();
  const [ifastOrder, setIfastOrder] = useState(null);
  const [checkOrderStatus] = useCheckOrderStatusMutation();
  const [cancelIfastOrder] = useCancelIfastOrderMutation();
  const [jeeblyOrder, setJeeblyOrder] = useState(null);
  // const [trackJeeblyOrder] = useTrackJeeblyOrderMutation();
  const [cancelJeeblyOrder] = useCancelJeeblyOrderMutation();

  /*handle tab chnge */
  const handleTabChange = async (key) => {
    if (key === "3" && order.logisticPartner==="IFAST" ) {
      await getIfastOrderStatus();
    }
    await props.fetchOrderDetailsByID();
  };

  const getIfastOrderStatus = async () => {
    try {
      if (!order?._id) return;
      dispatch(LoaderAction.setLoading(true));
      const data = await checkOrderStatus({
        orderId: order._id,
        trackingId:order.logisticPartnerMetadata.IFAST.trackingDeliveryInfo.tracking_no,
        barcode:order.logisticPartnerMetadata.IFAST.trackingDeliveryInfo.barcode
      });
      if ( data?.data) {
        setIfastOrder(data?.data);
      } else {
        UTILS.errorNotification(errorHandler(data?.error));
        setIfastOrder(null);
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const cancelOrder= async ()=>{
    try {
      dispatch(LoaderAction.setLoading(true));
      if (!order?._id) return;
      const data = await cancelIfastOrder({
        orderId: order._id,
        trackingId:order.logisticPartnerMetadata.IFAST.trackingDeliveryInfo.tracking_no
      });
      if (data?.data?.data) {
        UTILS.successNotification(
          t("Order has been cancelled successfully")
        );
         await props.fetchOrderDetailsByID();

      } else {
        UTILS.errorNotification(errorHandler(t("Unable to cancel the order. Please contact to ifast support for further info.")));
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }

  }

  return (
    <ModalTabs setOpen={setOpen} handleTabChange={handleTabChange}>
      <TabPane tab={t("SEND ORDER")} key="1">
        <CreateClaim
          fetchOrderDetailsByID={props.fetchOrderDetailsByID}
          customKey="create-claim"
        />
      </TabPane>
      <TabPane tab={t("ORDER DETAIL")} key="3">
        <ClaimInfo
          key="order-status"
          ifastOrder={ifastOrder}
          getIfastOrderStatus={getIfastOrderStatus}
        />
      </TabPane>
      <TabPane tab={t("CANCEL ORDER")} key="4">
        <CancelClaim
          key="cancel-claim"
          cancelOrder={cancelOrder}
          ifastOrder={ifastOrder}
        />
      </TabPane>
      <TabPane tab={t("IFAST SUPPORT CENTER")} key="5">
        <IFastSupport jeeblyOrder={jeeblyOrder} />
      </TabPane>
    </ModalTabs>
  );
};

export default DeliveryService;
